import { useIntl } from 'react-intl';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

import valueProps from './data';
import { Column, GridWrapper, Section } from './styles';
import { ValueProp } from './types';

const StressRelaxSleep = () => {
	const { formatMessage } = useIntl();
	return (
		<Section>
			<GridWrapper>
				{Object.values(valueProps).map(({ icon, label, body }: ValueProp) => (
					<Column key={label.id}>
						{icon}
						<Text weight={FontWeights.Medium} size={FontSizes.lg} el="h2">
							{formatMessage(label)}
						</Text>
						<Text size={FontSizes.base} el="p">
							{formatMessage(body)}
						</Text>
					</Column>
				))}
			</GridWrapper>
		</Section>
	);
};

export default StressRelaxSleep;
